import { useQuery } from '@tanstack/react-query';
import { api } from './client';

/**
 * Patron özeti (`GET /api/reports/owner-summary`): bugün / bu hafta / bu ay TEK istekte.
 *
 * PARA KURALI (CLAUDE.md kural 4): tüm tutarlar sunucudan `Decimal` string gelir; panel yalnız
 * biçimlendirir, toplamaz, bölmez. Yüzdeler (`sharePct`) de sunucuda hesaplanır.
 */
export type OwnerSummaryPeriodKey = 'today' | 'week' | 'month';

export interface OwnerSummaryPeriod {
  fromDay: string;
  toDay: string;
  revenue: { ours: string; panelDelivered: string; total: string };
  deliveries: number;
  jugs: number;
  /** Yalnız BİZİM teslimatlarımızın ödeme türü kırılımı. */
  collections: { cash: string; card: string; online: string; credit: string };
  /** Alınan boş: bizim marka ve yabancı marka. */
  emptiesReceived: { own: number; foreign: number };
  /** Kaynak başına (Telefon/Getir/Hayat/Abant) teslim edilen adet, ciro ve pay. */
  bySource: { source: string; delivered: number; revenue: string; sharePct: number }[];
  byDriver: {
    driverId: string;
    name: string;
    plate: string;
    deliveries: number;
    jugs: number;
    collected: string;
  }[];
}

export interface OwnerSummary {
  generatedAt: string;
  periods: Record<OwnerSummaryPeriodKey, OwnerSummaryPeriod>;
  /** Anlık durum (dönemden bağımsız): müşterilerde duran damacana ve alınmış depozito. */
  openDeposit: { jugsOnHand: number; depositHeld: string; customers: number };
}

export function useOwnerSummary() {
  return useQuery({
    queryKey: ['reports', 'owner-summary'],
    queryFn: () => api.get<OwnerSummary>('/api/reports/owner-summary'),
  });
}
